import React, { useEffect, useState, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { useMetaPixel } from './components/useMetaPixel';
import { scrollToPurchaseSection } from './utils';
const BelowFold = lazy(() => import('./components/BelowFold').then(({
  BelowFold
}) => ({
  default: BelowFold
})));
export function App() {
  const [isBelowFoldReady, setIsBelowFoldReady] = useState(false);
  const [shouldScrollToPurchase, setShouldScrollToPurchase] = useState(false);
  useMetaPixel();
  useEffect(() => {
    let hasRequestedBelowFold = false;
    const removeLoadListener = () => {
      window.removeEventListener('scroll', loadWhenApproachingContent);
    };
    const loadBelowFold = () => {
      if (hasRequestedBelowFold) return;
      hasRequestedBelowFold = true;
      removeLoadListener();
      setIsBelowFoldReady(true);
    };
    const loadWhenApproachingContent = () => {
      if (window.scrollY + window.innerHeight >= 900) loadBelowFold();
    };
    window.addEventListener('scroll', loadWhenApproachingContent, {
      passive: true
    });
    return removeLoadListener;
  }, []);
  useEffect(() => {
    if (!isBelowFoldReady || !shouldScrollToPurchase) return;
    let animationFrame = 0;
    const scrollToPurchase = () => {
      if (!scrollToPurchaseSection()) {
        animationFrame = window.requestAnimationFrame(scrollToPurchase);
        return;
      }
      setShouldScrollToPurchase(false);
    };
    scrollToPurchase();
    return () => window.cancelAnimationFrame(animationFrame);
  }, [isBelowFoldReady, shouldScrollToPurchase]);
  const handlePurchaseRequest = () => {
    setShouldScrollToPurchase(true);
    setIsBelowFoldReady(true);
  };
  return <div className="min-h-screen bg-slate-950 text-slate-50 selection:bg-brand-500/30" data-id="element-0" data-mp="3dle1ulujigpf">
      <main data-id="element-1" data-mp="nvsvva68mxyl">
        <Hero onPurchaseRequest={handlePurchaseRequest} data-id="element-2" data-mp="nw2cw89b1us5" />
        {isBelowFoldReady && <Suspense fallback={null} data-id="element-3" data-mp="sudlygrs019b">
            <BelowFold data-id="element-4" data-mp="stc6m03q8sls" />
          </Suspense>}
      </main>
    </div>;
}